import React, { useEffect } from 'react';

import { Page, PageContent, PageHeader } from '@vlabs/monokit/shared/ui/page';
import { useHasPermission } from '@vlabs/permissions';
import {
  Control, Divider, Grid, GridRow, GridCol, Fold,
} from '@vlabs/uikit';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  EventPolicySubForm,
  FaceSamplePolicySubForm,
  BodySamplePolicySubForm,
  CommonSubForm,
  EstimationsFaceSubForm,
  EstimationsBodySubForm,
  MatchPolicySubForm,
  TagPolicySubForm,
  ImageOriginPolicySubForm,
  CallbacksPolicySubForm,
  PeopleCountSubForm,
  LivenessSubForm,
  FaceOcclusionSubForm,
  DeepfakeSubForm,
  FaceQualitySubForm,
} from './forms';

import './EditHandlerForm.sass';

export function EditHandlerForm({
  onSubmit,
  values = undefined,
}) {
  const { t } = useTranslation();
  const formMethods = useForm({ defaultValues: values });
  const { handleSubmit, reset } = formMethods;
  const canUpdate = useHasPermission('handler', 'update');

  useEffect(() => {
    if (values) reset(values);
  }, [reset, values]);

  const onAction = canUpdate ? (
    <Control.Button
      type="submit"
      variant="outlined"
    >
      {t('кнопка.сохранить')}
    </Control.Button>
  ) : null;

  return (
    <FormProvider {...formMethods}>
      <Page>
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{ flex: 1, pointerEvents: canUpdate ? 'auto' : 'none', opacity: canUpdate ? undefined : 0.6 }}
        >
          <PageContent>
            <PageHeader
              actions={onAction}
              title={t('handlers:edit page.title')}
            />
            <div />
            <Grid>
              <GridRow>
                <GridCol cols={6}>
                  <Fold
                    isOpen
                    testId="commonSection"
                    title={t('handlers:setup sections.general')}
                  >
                    <CommonSubForm />
                  </Fold>
                  <Divider />
                  <Fold
                    isOpen
                    testId="faceAttributes"
                    title={t('handlers:setup sections.determined face attributes')}
                  >
                    <EstimationsFaceSubForm />
                  </Fold>
                  <Divider />

                  <LivenessSubForm />
                  <Divider />

                  <DeepfakeSubForm />
                  <Divider />

                  <FaceQualitySubForm />
                  <Divider />

                  <FaceOcclusionSubForm />
                  <Divider />

                  <Fold
                    isOpen
                    testId="bodyAttributes"
                    title={t('handlers:setup sections.determined body attributes')}
                  >
                    <EstimationsBodySubForm />
                  </Fold>
                  <Divider />

                  <PeopleCountSubForm />
                  <Divider />

                  <Fold
                    isOpen
                    testId="matchPolicy"
                    title={t('handlers:setup sections.labels')}
                  >
                    <MatchPolicySubForm />
                  </Fold>

                </GridCol>

                <GridCol cols={6}>
                  <FaceSamplePolicySubForm />
                  <Divider />
                  <BodySamplePolicySubForm />
                  <Divider />
                  <ImageOriginPolicySubForm />
                  <Divider />
                  <EventPolicySubForm />
                  <Divider />
                  <Fold
                    isOpen
                    testId="tagPolicy"
                    title={t('handlers:setup sections.tagging parameters')}
                  >
                    <TagPolicySubForm />
                  </Fold>
                  <Divider />
                  <Fold
                    isOpen
                    testId="callbacksPolicy"
                    title={t('handlers:setup sections.callbacks')}
                  >
                    <CallbacksPolicySubForm />
                  </Fold>
                </GridCol>
              </GridRow>
            </Grid>
          </PageContent>
        </form>
      </Page>
    </FormProvider>
  );
}
